<template>
  <div class="page">
    <div class="problems">
      <transition name="fade" mode="out-in" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:leave="leave" v-bind:css="false">
        <ProblemItem key="0" v-if="0 === currentProblemsIndex" v-on:selectAnswer="selectAnswer" v-bind:finishedType="finishedType" v-bind:finished="finished" v-bind:problem="problems[0]" v-bind:answers="answers"></ProblemItem>
        <ProblemItem key="1" v-if="1 === currentProblemsIndex" v-on:selectAnswer="selectAnswer" v-bind:finishedType="finishedType" v-bind:finished="finished" v-bind:problem="problems[1]" v-bind:answers="answers"></ProblemItem>
        <ProblemItem key="2" v-if="2 === currentProblemsIndex" v-on:selectAnswer="selectAnswer" v-bind:finishedType="finishedType" v-bind:finished="finished" v-bind:problem="problems[2]" v-bind:answers="answers"></ProblemItem>
        <ProblemItem key="3" v-if="3 === currentProblemsIndex" v-on:selectAnswer="selectAnswer" v-bind:finishedType="finishedType" v-bind:finished="finished" v-bind:problem="problems[3]" v-bind:answers="answers"></ProblemItem>
        <ProblemItem key="4" v-if="4 === currentProblemsIndex" v-on:selectAnswer="selectAnswer" v-bind:finishedType="finishedType" v-bind:finished="finished" v-bind:problem="problems[4]" v-bind:answers="answers"></ProblemItem>
      </transition>
    </div>
    <div class="background">
      <div v-for="(val, i) in ['bg_block_01', 'bg_block_02', 'bg_block_03', 'bg_block_04']" v-bind:key="i">
        <template v-if="i < 3">
          <div class="background-image-wrapper" v-show="i === currentProblemsIndex">
            <picture>
              <source media="(min-width: 768px)" v-bind:srcset=" require(`@/assets/img/pages/index/${val}_large.png`)" />
              <img v-bind:src="require(`@/assets/img/pages/index/${val}.png`)" class="display-block img-responsive width-full"/>
            </picture>
          </div>
        </template>
        <template v-else>
          <div class="background-image-wrapper" v-show="currentProblemsIndex > 2">
            <picture>
              <source media="(min-width: 768px)" v-bind:srcset="require(`@/assets/img/pages/index/${val}_large.png`)"/>
              <img v-bind:src="require(`@/assets/img/pages/index/${val}.png`)" class="display-block img-responsive width-full" />
            </picture>
          </div>
        </template>
      </div>
    </div>
    <div class="illust display-none large-display-block">
      <div v-for="(val, i) in ['illust_01_large','illust_02_large', 'illust_03_large','illust_04_large',]" v-bind:key="i">
        <template v-if="i < 3">
          <div class="background-image-wrapper" v-show="i === currentProblemsIndex">
            <img v-bind:src="require(`@/assets/img/pages/index/${val}.png`)" class="display-block img-responsive" />
          </div>
        </template>
        <template v-else>
          <div class="background-image-wrapper" v-show="currentProblemsIndex > 2">
            <img v-bind:src="require(`@/assets/img/pages/index/${val}.png`)" class="display-block img-responsive" />
          </div>
        </template>
      </div>
    </div>
    <div class="progress-bar-wrapper">
      <div class="progress-bar">
        <div v-for="(problem, i) in problems" v-bind:key="i" class="progress-bar-step-wrapper">
          <div v-bind:class="{ active: currentProblemsIndex >= i, deactive: ( getAnswerById(4) && getAnswerById(4).label === 'いる') && problem.id === 5 }" v-on:click="goTo(i)" class="progress-bar-step">{{ problem.id }}</div>
        </div>
      </div>
      <div class="illust large-display-none" v-for="(val, i) in ['illust_01', 'illust_02', 'illust_03', 'illust_04']" v-bind:key="i">
        <template v-if="i < 3">
          <div class="illust-item" v-show="i === currentProblemsIndex">
            <img v-bind:src="require(`@/assets/img/pages/index/${val}.png`)" class="img-responsive vertical-align-bottom" />
          </div>
        </template>
        <template v-else>
          <div class="illust-item" v-show="2 < currentProblemsIndex">
            <img v-bind:src="require(`@/assets/img/pages/index/${val}.png`)" class="img-responsive vertical-align-bottom" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Problems from "@/model/problems";
import ProblemItem from "@/components/ProblemItem";
import Velocity from "velocity-animate";
import "velocity-ui-pack";
import picturefill from "picturefill";

export default {
  name: "Problem",
  components: { ProblemItem },
  data() {
    return {
      currentProblemsIndex: 0,
      problems: Problems,
      answers: [],
      finished: false,
      finishedType: null,
      resultId: null,
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {},
  methods: {
    getAnswerById: function(id){
      for (let i = 0; i < this.$data.answers.length; i++) {
        if (this.$data.answers[i].id === id) {
          return this.$data.answers[i].answer;
        }
      }
      return false;
    },
    goTo(index) {
      this.$data.currentProblemsIndex = index;
    },
    selectAnswer(answer) {
      const self = this;
      if(answer.id === 4){
        const temp = self.$data.answers.filter(function (element) {
          return element.id !== 5;
        });
        this.$data.answers = temp;
      }
      //渡ってきたオブジェクトとIDが同じではないオブジェクトのみの配列を作成
      const temp = self.$data.answers.filter(function (element) {
        return element.id !== answer.id;
      });
      //渡ってきたオブジェクトを配列に追加する
      temp.push(answer);
      //作成した配列をデータに代入する
      this.$data.answers = temp;

      if(this.getAnswerById(1) && this.getAnswerById(2) && this.getAnswerById(3) && this.getAnswerById(4) && this.getAnswerById(4).value === "1"  && !this.getAnswerById(5)){
          this.$data.finished = true;
          this.$data.finishedType = "4";
      }else if( this.getAnswerById(1) && this.getAnswerById(2) && this.getAnswerById(3) && this.getAnswerById(4)  && this.getAnswerById(5) ){
        this.$data.finished = true;
        this.$data.finishedType = "5";
      }else{
        this.$data.finished = false;
        this.$data.finishedType = null;
      }

      if (this.$data.currentProblemsIndex < 4 && !this.$data.finished && this.getAnswerById(4).label !== 'いる' ) {
        this.$data.currentProblemsIndex++;
      }
    },
    beforeEnter: function (el) {
      el.style.opacity = 0;
      el.querySelectorAll("button").forEach((element) => {
        element.style.opacity = 0;
      });
    },
    enter: function (el, done) {
      picturefill();
      Velocity.RegisterEffect("buttonAnimation", {
        defaultDuration: 100,
        calls: [[{ opacity: 1, scale: 0.98 }], [{ scale: 1, opacity: 1 }]],
        reset: { scale: 1, opacity: 1 },
      });
      Velocity(el.querySelectorAll("button"), "buttonAnimation", {
        stagger: 100,
        easing: "easeInQuart",
        delay: 200,
      });
      Velocity(el, { opacity: 1, scale: 1 }, { duration: 750, complete: done });
    },
    leave: function (el, done) {
      Velocity(el, { opacity: 0 }, { duration: 0, delay: 0, complete: done });
    },
  },
  mounted: function () {
    picturefill();
  },
};
</script>
<style lang="scss" scoped>
/*
ページ
*/
.page {
  position: relative;
  background-image: url("../assets/img/pages/index/bg.png");
  @media (min-width: 992px) {
  }
}
/*
設問
*/
.problems {
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 25px);
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 992px) {
    min-height: auto;
    height: 575px;
  }
}
.problem {
  @media (min-width: 992px) {
  }
}

/*
ブロック背景
*/
.background {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}
.background-image-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

/*
イラスト
*/
@media (min-width: 992px) {
  .illust {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
@media (max-width: 991px) {
  .illust {
    position: absolute;
    bottom: 10px;
    width: 208px;
    width: 54.4666vw;
    max-width: 300px;
    z-index: -1;
  }
  .illust-item {
    position: absolute;
    bottom: 0;

    left: -9px;
  }
}

/*
進捗指標
*/
.progress-bar-wrapper {
  position: absolute;
  bottom: 10px;
  bottom: 30px;
  max-width: 460px;
  left: 15px;
  right: 15px;
  margin: auto;
  z-index: 1;
  @media (min-width: 992px) {
    right: 20px;
    bottom: 17px;
    left: auto;
    width: 100%;
    max-width: 685px;
  }
}

.progress-bar {
  border-radius: 8px;
  border: solid 2px #c6051c;
  overflow: hidden;
  display: flex;
  background-color: #c6051c;
  box-shadow: 3px 4px 1px 0px rgba(0, 0, 0, 0.2);
}

.progress-bar-step-wrapper {
  flex-grow: 1;
}

.progress-bar-step {
  position: relative;
  cursor: pointer;
  z-index: 0;
  color: #c6051c;
  text-align: center;
  height: 2.5em;
  line-height: 2.5em;
  font-size: 18px;
  border: solid 1px rgba(#cccccc, 0.3);
  background-clip: border-box;
  background-origin: padding-box;
  background-color: #ffffff;
  transition: background-color 0.1s linear;
  @media (min-width: 992px) {
    font-size: 22px;
  }
}
.progress-bar-step.active {
  background-color: #c6051c;
  color: #ffffff;
}
.progress-bar-step.deactive {
  background-color: #e5e5e5;
  color: #ffffff;
}
/*
登録番号
*/
// .registration-number{
//   position: absolute;
//   bottom: 0px;
//   right: 0px;
//   background-color: rgba(255,255,255,0.3);
//   margin: 2px 2px;
//   padding: 0px 5px;
//   z-index: 1;
//   font-size: 11px;
//   color: #333333;
//   font-weight: normal;
//   text-align: right;
//   font-family: sans-serif;
//   @media (min-width: 992px) {
//     display: none;
//   }
// }
</style>
